import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import { enqueueSnackbar } from 'notistack';
import queryString from 'query-string';
import { useParams, useLocation } from 'react-router-dom';

import ReportEditor from '../../components/common/ReportEditor';
import CaseService from '../../services/cases.service';
import { sanitizeRichText } from '../../utils/sanitize';

const useStyles = makeStyles(() => ({
  contentWrapper: {
    backgroundColor: 'white',
    borderRadius: '8px',
    display: 'flex',
    height: '100vh',
    maxHeight: '90vh',
    maxWidth: 'min(800px, 90vw)',
    overflowY: 'auto',
    padding: '32px 16px 32px 48px',
    width: '100%',
  },
  editorContainer: {
    alignItems: 'center',
    backgroundColor: '#f3f3f3',
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    textAlign: 'initial',
    width: '100vw',
  },
  htmlModal: {
    overflowY: 'auto',
    paddingRight: '24px',
  },
}));

const ReportEditorView = () => {
  const classes = useStyles();
  const { caseId } = useParams();
  const { search } = useLocation();
  const { token, readMode = false } = queryString.parse(search);
  const [caseData, setCaseData] = useState(null);

  useEffect(() => {
    if (!token) return null;

    localStorage.setItem('accessToken', token);

    return () => {};
  }, [token]);

  const getCase = async (id) => {
    try {
      const caseService = new CaseService();
      const response = await caseService.getCase(id);

      setCaseData(response);
    } catch (error) {
      setCaseData(null);
      enqueueSnackbar(error.message, { autoHideDuration: 10000, variant: 'error' });
    }
  };

  useEffect(() => {
    if (!caseId) return null;

    getCase(caseId);
    return () => {};
  }, [caseId, token]);

  const handleClose = () => {
    window.open(window.location.href, '_self', '');
    window.close();
  };

  const cleanReport = sanitizeRichText(caseData?.caseReport?.content, { USE_PROFILES: { html: true } });

  return (
    <div className={`${classes.editorContainer} table-container`}>
      {readMode === 'true' ? (
        <div className={classes.contentWrapper}>
          <div className={classes.htmlModal} dangerouslySetInnerHTML={{ __html: cleanReport }} />
        </div>
      ) : (
        <ReportEditor
          isRecorder
          caseReport={caseData?.caseReport}
          onClose={handleClose}
          caseId={caseId}
          user={caseData?.assignee}
          workspaceSignatureId={caseData?.workspace.signatureId}
        />
      )}
    </div>
  );
};

export default ReportEditorView;
